<template>
  <div class="house-importer-specific-values-popup">
    <app-popup title="Расчет удельных показаний" :active.sync="active" width="620px">
      <div>
        <div class="house-importer-specific-values-popup__row" v-for="(tariffRow, index) in tariffsRows" :key="index">
          <app-v-select :options="tariffs"
                        label="Название тарифа"
                        select-label="name"
                        :reduce-function="opt => opt.name"
                        class="house-importer-specific-values-popup__select"
                        :clearable="false"
                        :searchable="true"
                        :appendToBody="true"
                        v-model="tariffRow.name"
          />
          <app-input label="Расчитанное значение" :value="tariffRow.value" :disabled="true" class="house-importer-specific-values-popup__input"/>
          <div class="house-importer-specific-values-popup__row-delete" @click="deleteRow(index)">
            <app-icon name="TrashIcon"/>
          </div>
        </div>

        <div class="house-importer-specific-values-popup__add">
          <span class="link-icon" @click="addRow">ДОБАВИТЬ ТАРИФ</span>
        </div>

        <div class="house-importer-specific-values-popup__buttons">
          <app-button :disabled="isSending" @click="calcValues" color="success">{{isSending ? 'Расчитываю' : (isSended ? 'Расчитано' : 'Расчитать')}}</app-button>
        </div>

      </div>
    </app-popup>
  </div>
</template>

<script>
  export default {
    name: "SpecificValuesPopup",
    props: {
      importInfo: {}
    },
    data(){
      return {
        isSending: false,
        isSended: false,
        active: false,
        tariffs: [],
        tariffsRows: [
          {
            name: null,
            value: null
          }
        ]
      }
    },
    methods: {
      async calcValues(){
        try{
          this.isSending = true;
          this.isSended = false;
          let names = this.tariffsRows.map(row => row.name).filter(name => name.length);
          let body = {
            import_id: this.importInfo.id,
            tarifs: JSON.stringify(names)
          };
          let {data} = await this.$http.get('import/houses/specific_values', {params: body});
          for (let i = 0; i < data.length; i++){
            this.tariffsRows[i].value = data[i];
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {
            this.isSending = false;
            this.isSended = true
          }, 300);
        }
      },
      deleteRow(index){
        this.tariffsRows.splice(index, 1);
      },
      addRow(){
        this.tariffsRows.push({
          name: null,
          value: null
        });
      },
      async getTariffs(){
        try{
          let {data} = await this.$http.get('import/houses/tarifs', {params: {import_id: this.importInfo.id}});
          this.tariffs = data;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.tariffs = []
        }
      },
      open(){
        this.active = true;
      }
    },
    created() {
      this.getTariffs();
    }
  }
</script>

<style lang="scss">
  .house-importer-specific-values-popup{

    &__row{
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      &-delete{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        cursor: pointer;

        &:hover{
          color: rgba(var(--app-danger), 1);
        }
      }
    }

    &__add{
      font-size: 10px;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 15px;
    }

    &__select{
      flex: 2;
      padding-right: 15px;
    }

    &__input{
      flex: 1;
      min-width: 180px;
      padding-right: 15px;
    }

    &__buttons{
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }
</style>